import * as React from 'react'
import { CircularProgress, styled } from '@design/pt-ui'
import { PlayCircleFilledTwoTone as PlayCircleFilledTwoToneIcon } from '@mui/icons-material'

export type Props = {
  thumbnail: string
  src: string
  height: number
}

const PlayerHolder = styled('div')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  background: '#000',
})

const BigPlayButton = styled('button')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  padding: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  lineHeight: 0,
})

const PlayIcon = styled(PlayCircleFilledTwoToneIcon)({
  width: 60,
  height: 60,
  fill: '#fff',
})

const Spinner = styled(CircularProgress)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: '#fff',
  pointerEvents: 'none',
})

export const VideoPlayer = (props: Props) => {
  const video = React.useRef<HTMLVideoElement>(null)

  const [started, setStarted] = React.useState<boolean>(false)
  const [waiting, setWaiting] = React.useState<boolean>(false)

  // A new source rewinds to the poster, so the overlay button comes back.
  React.useEffect(() => {
    setStarted(false)
    setWaiting(false)
  }, [props.src])

  const handlePlay = () => {
    setStarted(true)
  }

  return (
    <PlayerHolder>
      <video
        ref={video}
        src={props.src}
        poster={props.thumbnail}
        height={props.height}
        width="100%"
        controls={true}
        playsInline={true}
        style={{ maxWidth: '100%', objectFit: 'contain' }}
        onPlay={handlePlay}
        onWaiting={() => setWaiting(true)}
        onPlaying={() => setWaiting(false)}
        onCanPlay={() => setWaiting(false)}
      />

      {waiting ? <Spinner size={40} /> : null}

      {started ? null : (
        <BigPlayButton
          type="button"
          aria-label="Play"
          onClick={() => video.current?.play()}>
          <PlayIcon />
        </BigPlayButton>
      )}
    </PlayerHolder>
  )
}

export default VideoPlayer
